import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IPlanWeek } from '@gray/domain/models/plan/plan-week.model';
import { IPlanWeekItem } from '@gray/domain/models/plan/plan-week-item.model';
import { EPlanGroupWeekItemType } from '@gray/domain/enums/plan-group-week-item-type.enum';

/** Moves one planner item to another week of the same plan. */
@Component({
  selector: 'coach-planner-transfer-modal',
  templateUrl: './planner-transfer-modal.component.html',
  styleUrl: './planner-transfer-modal.component.scss',
})
export class PlannerTransferModalComponent {
  @Input() weeks: IPlanWeek[] = [];
  @Input() item!: IPlanWeekItem;

  constructor(
    public modal: NgbActiveModal,
  ) {
  }

  itemTitle(): string | null {
    if (this.item?.type === EPlanGroupWeekItemType.Text) {
      return this.item?.text ?? null;
    }
    if (this.item?.type === EPlanGroupWeekItemType.Video) {
      return this.item?.video?.title ?? null;
    }

    return this.item?.lessonTopic?.name ?? null;
  }
}
